<template>
    <div class="flex h-full flex-col items-center justify-center gap-4">
        <div
            class="h-8 w-8 animate-spin rounded-full border-2 border-black border-t-transparent"
        />
        <slot />
    </div>
</template>